import clsx from 'clsx';

const TONES = [
  'bg-jade-100 dark:bg-jade-900/50 text-jade-700 dark:text-jade-300',
  'bg-coral-100 dark:bg-coral-700/30 text-coral-600 dark:text-coral-300',
  'bg-sand-200 dark:bg-sand-700 text-sand-700 dark:text-sand-100',
];

export default function Avatar({ name = '', size = 38, tone, className = '' }) {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?';
  const toneClass =
    tone != null
      ? TONES[tone % TONES.length]
      : TONES[(initials.charCodeAt(0) || 0) % TONES.length];
  return (
    <span
      className={clsx(
        'shrink-0 rounded-full grid place-items-center font-display font-semibold',
        toneClass,
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials}
    </span>
  );
}
